<app-navsec></app-navsec>
<div class="container">
    <div class="col-lg-12">
        <h3>
            <img src="../../../assets/img/money.png" width="70" class="img-fluid" alt="Responsive image"> Información de transacciones
        </h3>
        <hr>
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-light">
                <tr>
                    <th scope="col">Fecha</th>
                    <th scope="col">Medio</th>
                    <th scope="col">Ref. pago</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Flete</th>
                    <th scope="col">Precio</th>
                    <th scope="col">acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of lista">
                    <td>{{item.fecha | date: 'medium'}}</td>
                    <td>{{item.pago}}</td>
                    <td>{{item.refCompra}}</td>
                    <td>{{item.estado}}</td>
                    <td>${{item.flete | number}}</td>
                    <td>${{item.total | number}}</td>
                    <td>
                        <button type="button" class="btn btn-success" (click)="openModal(item)" title="Ver detalle" data-toggle="modal" data-target="#staticBackdrop">
                            <i class="fa fa-list" aria-hidden="true"></i>
                          </button>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>

    </div>
</div>
<br><br><br><br><br><br><br><br><br><br>
<app-footer></app-footer>

<!-- Modal -->
<div *ngIf="compraSel" class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Detalle de compra</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" style="background-color: #fff;">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Producto</th>
                            <th scope="col"></th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of compraSel.compras">
                            <td><img [src]="item.imagenProd" class="img-fluid" alt="Responsive image" width="60"></td>
                            <td>
                                <h5>{{item.nombreprod | titlecase}}</h5>
                            </td>
                            <td>{{item.cantidad}}</td>
                            <td>${{item.precio | number}}</td>
                            <td>${{item.total | number}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>
